/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PropsWithChildren } from "react";
import { Else, If, Then } from "react-if";
import { Link } from "react-router-dom";
import { Text } from "@nordcloud/gnui";
import { isNotNil } from "~/tools";

type Props = PropsWithChildren<{
  to?: string;
  region: string;
}>;

export function AccountRegionCell({ to, region, children }: Props) {
  return (
    <>
      <If condition={isNotNil(to)}>
        <Then>
          <Link to={to ?? ""}>{children}</Link>
        </Then>
        <Else>{children}</Else>
      </If>
      <Text tag="div" size="sm">
        {region}
      </Text>
    </>
  );
}
